import styled from 'styled-components'
import { Segment } from 'semantic-ui-react'

export const Wrapper = styled(Segment)`
  width: 40%;
  min-width: 400px;
`
